import React from 'react';

import { Table, Message } from 'semantic-ui-react';

import { multiCaseGet } from 'libs/format';

import { GoogleLocationPropType } from '../../../AccountSettings/AccountSettings.types';
import { getBusinessType } from '../../AccountLocationList.utils';

const propTypes = {
  gmbLocation: GoogleLocationPropType.isRequired,
};

function LocationStatus({ gmbLocation }) {
  const metadata = multiCaseGet(gmbLocation, 'metadata') || {};
  const duplicateLocation = multiCaseGet(metadata, 'duplicateLocation');
  const hasVoiceOfMerchant = multiCaseGet(metadata, 'hasVoiceOfMerchant');
  const businessType = getBusinessType(metadata);

  return (
    <Table.Cell>
      {duplicateLocation && (
        <Message warning size="mini">
          <Message.Header>Duplicate Location Detected</Message.Header>
          This location may be a duplicate. Please verify before proceeding.
        </Message>
      )}
      <div style={{ marginBottom: '5px' }}>
        <strong>Verification:</strong>{' '}
        {hasVoiceOfMerchant ? (
          <span style={{ color: 'green' }}>✓ Verified by merchant</span>
        ) : (
          <span style={{ color: 'red' }}>⚠ Not verified</span>
        )}
      </div>
      <div>
        <strong>Business Type:</strong> {businessType}
      </div>
    </Table.Cell>
  );
}

LocationStatus.propTypes = propTypes;

export default LocationStatus;
